import "./index.css";
import React, { memo } from "react";
import { FaPlus, FaRandom } from "react-icons/fa";
import { Handle } from "reactflow";

import { ValidatorFn } from "../../../helpers/validationConnector";
import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export const WPP_FLOWS_ANSWERED_HANDLE = "flow-answered";
export const WPP_FLOWS_DEFAULT_HANDLE = "flow-default";

export default memo(({ data, ...rest }) => {
	const outputs = [
		{ id: WPP_FLOWS_ANSWERED_HANDLE, title: "Formulário respondido" },
		// Com o envio obrigatório o bot só sai quando o flow é respondido.
		...(data.wppFlows?.required
			? []
			: [{ id: WPP_FLOWS_DEFAULT_HANDLE, title: "Padrão" }]),
	];

	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle
				type="target"
				position="left"
				isConnectable={true}
				isConnectableStart={false}
			/>

			<NodeHeader
				data={data}
				rest={rest}
				icon={<FaRandom />}
				text="Whatsapp Flows"
			/>

			<div className="sendMessageContent">
				<div title={`Enviar Flow: ${data.wppFlows?.id}`}>
					Enviar Flow: {data.wppFlows?.id}
				</div>
			</div>

			<div className="questionButtons">
				{outputs.map((output, i) => (
					<div
						key={output.id}
						className={i === outputs.length - 1 ? "item-last" : ""}
					>
						<div className="conditionalContent">{output.title}</div>
						<Handle
							type="source"
							position="right"
							id={output.id}
							className="handle"
							isConnectable={true}
							isValidConnection={ValidatorFn()}
						>
							<FaPlus size={8} style={{ pointerEvents: "none" }} />
						</Handle>
					</div>
				))}
			</div>
		</>
	);
});
